// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__395mr","buttons":"Footer_buttons__1hDeS"};